<mat-sidenav-container class="shell" [class.shell--nav-compact]="navCompact()">
  <mat-sidenav
    class="shell__nav"
    [mode]="drawerMode()"
    [opened]="sidenavOpened()"
    [fixedInViewport]="true"
    [autoFocus]="false"
    (openedChange)="onOpened($event)"
  >
    <a class="shell__brand" routerLink="/inicio" (click)="closeMobile()">
      <span class="shell__mark" aria-hidden="true">C</span>
      <span class="shell__word">COGRAFA</span>
      <span class="shell__badge">BaFi</span>
    </a>

    <nav class="shell__menu shell__menu--enter" aria-label="Navegación principal">
      @for (group of groups(); track group.label) {
        <p class="shell__group-label">{{ group.label }}</p>
        <mat-nav-list class="shell__list">
          @for (item of group.items; track item.link) {
            <a
              mat-list-item
              disableRipple
              class="shell__item"
              [routerLink]="item.link"
              routerLinkActive="shell__item--active"
              [matTooltip]="item.label"
              matTooltipPosition="after"
              [matTooltipDisabled]="!navCompact()"
              (click)="closeMobile()"
            >
              <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
              <span matListItemTitle>{{ item.label }}</span>
              @if (badges()[item.link]; as count) {
                <span class="shell__nav-badge" [class.shell__nav-badge--alert]="folioAlert()">{{ count }}</span>
              }
            </a>
          }
        </mat-nav-list>
      }
    </nav>

    <div class="shell__nav-foot">
      <button matButton type="button" class="shell__sign-out" (click)="auth.logout()">
        <mat-icon>logout</mat-icon>
        <span>Cerrar sesión</span>
      </button>
      <span class="shell__who">{{ auth.user()?.displayName }}</span>
      <span class="shell__env">{{ envLabel }} · v{{ version }}</span>
    </div>
  </mat-sidenav>

  <mat-sidenav-content class="shell__main">
    <mat-toolbar class="shell__toolbar">
      <button matIconButton type="button" [attr.aria-label]="sidenavOpened() ? 'Ocultar menú' : 'Mostrar menú'" (click)="toggleNav()">
        <mat-icon>{{ sidenavOpened() ? 'menu_open' : 'menu' }}</mat-icon>
      </button>
      <div class="shell__copy" [class.shell__copy--pulse]="titlePulse()">
        <span class="shell__title">{{ pageTitle() }}</span>
        <span class="shell__sub">{{ pageSubtitle() }}</span>
      </div>
      <span class="shell__spacer"></span>
      @if (live()) { <span class="shell__chip">{{ live() }}</span> }
      @if (online()) { <span class="shell__chip shell__chip--soft" [matTooltip]="online()">En línea</span> }
      <button matIconButton type="button" aria-label="Ayuda" matTooltip="Ayuda" (click)="openHelp()">
        <mat-icon>help_outline</mat-icon>
      </button>
      <button matIconButton type="button" [matMenuTriggerFor]="themeMenu" [attr.aria-label]="'Tema: ' + theme.current().label" matTooltip="Tema">
        <mat-icon>{{ theme.current().icon }}</mat-icon>
      </button>
      <mat-menu #themeMenu="matMenu">
        @for (opt of theme.options; track opt.id) {
          <button mat-menu-item type="button" (click)="theme.setTheme(opt.id)">
            <mat-icon>{{ opt.icon }}</mat-icon>
            <span>{{ opt.label }}</span>
          </button>
        }
      </mat-menu>
      <button matIconButton type="button" class="shell__account" [matMenuTriggerFor]="accountMenu" aria-label="Cuenta">
        <span class="shell__avatar">{{ initial() }}</span>
      </button>
      <mat-menu #accountMenu="matMenu">
        <div class="shell__account-card" (click)="$event.stopPropagation()">
          <strong>{{ auth.user()?.displayName }}</strong>
          <span>{{ auth.role() }}</span>
        </div>
        <button mat-menu-item type="button" (click)="setDensity(nav.density() === 'compact' ? 'expanded' : 'compact')">
          <mat-icon>view_sidebar</mat-icon>
          <span>{{ nav.density() === 'compact' ? 'Menú completo' : 'Menú compacto' }}</span>
        </button>
        <button mat-menu-item type="button" (click)="setMode(nav.mode() === 'overlay' ? 'docked' : 'overlay')">
          <mat-icon>layers</mat-icon>
          <span>{{ nav.mode() === 'overlay' ? 'Menú fijo' : 'Menú superpuesto' }}</span>
        </button>
        <button mat-menu-item type="button" (click)="lock()">
          <mat-icon>lock</mat-icon>
          <span>Bloquear</span>
        </button>
        <button mat-menu-item type="button" (click)="auth.logout()">
          <mat-icon>logout</mat-icon>
          <span>Salir</span>
        </button>
      </mat-menu>
    </mat-toolbar>

    <div class="shell__body">
      @if (locked()) {
        <form class="shell__lock" (ngSubmit)="unlock()">
          <mat-icon>lock</mat-icon>
          <h2>Sesión bloqueada</h2>
          <p>Confirma la contraseña de {{ auth.user()?.userName }}.</p>
          <mat-form-field appearance="outline">
            <mat-label>Contraseña</mat-label>
            <input matInput type="password" name="unlock" [(ngModel)]="unlockPassword" />
          </mat-form-field>
          @if (unlockError()) { <p class="bad">{{ unlockError() }}</p> }
          <button matButton="filled" type="submit">Desbloquear</button>
        </form>
      } @else {
        <router-outlet />
      }
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
